// /utils/textFormatting.js
import React from "react";

// Text formatting helper - handles **bold**, *bold*, and trailing emoji
export const textFormatting = (text) => {
    if (!text) return null;
    let result = [];
    let remaining = String(text);
    let keyIdx = 0;
    
    // First: extract trailing emoji (at end of message)
    // Emoji regex covers most common emoji including multi-char ones
    const emojiRegex = /[\u{1F300}-\u{1F9FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}]+$/u;
    const trailingEmojiMatch = remaining.match(emojiRegex);
    let trailingEmoji = null;
    
    if (trailingEmojiMatch) {
      trailingEmoji = trailingEmojiMatch[0];
      remaining = remaining.slice(0, -trailingEmoji.length).trimEnd();
    }
    
    // Second: process **bold** and *bold* formatting
    const boldRegex = /(\*\*[^*]+\*\*|\*[^*]+\*)/g;
    let lastIndex = 0;
    let match;
    
    while ((match = boldRegex.exec(remaining)) !== null) {
      if (match.index > lastIndex) {
        result.push(<span key={keyIdx++}>{remaining.slice(lastIndex, match.index)}</span>);
      }
      const matched = match[0];
      if (matched.startsWith('**') && matched.endsWith('**')) {
        result.push(<strong key={keyIdx++}>{matched.slice(2, -2)}</strong>);
      } else if (matched.startsWith('*') && matched.endsWith('*')) {
        result.push(<strong key={keyIdx++}>{matched.slice(1, -1)}</strong>);
      }
      lastIndex = boldRegex.lastIndex;
    }
    if (lastIndex < remaining.length) {
      result.push(<span key={keyIdx++}>{remaining.slice(lastIndex)}</span>);
    }
    
    // Add trailing emoji with larger styling
    if (trailingEmoji) {
      result.push(<span key={keyIdx++} className="message-emoji">{trailingEmoji}</span>);
    }
    
    return result.length > 0 ? result : null;
  };
